const E = {
  footer: 'Privacy © Bureau Veritas. All Rights Reserved.',
};

const F = {
  footer:
    'Confidentialité © Bureau Veritas, Tous droits réservés.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/loginLayout.js